import React from 'react';
import { Link } from "react-router-dom";
import BackgroundBeams_1 from '../../components/ui/BackgroundBeams_1.jsx';
import HomeMetaPills, { HomeActionButton } from './home_ai_pill.jsx';

export default function HomeHeroSection({
    glassPanel,
}) {
    const scrollToSection = (sectionId) => {
        if (typeof window === 'undefined') return;
        const target = document.getElementById(sectionId);
        if (!target) return;
        const headerOffset = 45;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: 'smooth',
        });
    };

    return (
        <section className={`${glassPanel} enter-hero text-left`}>
            <div className="mb-1 text-[11px] font-medium uppercase tracking-[0.16em] text-slate-300/80 sm:text-xs">
                Hust Media — A Website by a HUST Graduate Passionate About Web
            </div>
            <h1 className="text-[27px] font-semibold tracking-tight text-white sm:text-[31px]">
                Engineering Scalable Solutions for Modern Web Platforms
            </h1>
            <div className="mt-0 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-slate-300 sm:text-[15px]">
                <span>Technical resources</span>
                <span className="text-slate-400">•</span>
                <span>Updated regularly</span>
            </div>

            <div className="mx-auto grid w-full max-w-none grid-cols-1 items-start gap-3 md:grid-cols-4 md:gap-5">
                <div className="md:col-span-3 md:pl-1">
                    <div className="mt-2 max-w-4xl px-0 py-0">
                        <div className="space-y-0.5 text-left sm:space-y-0.5">
                            <div className="flex items-start gap-2.5 text-base leading-7 text-slate-100 sm:text-[17px]">
                                <div className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-pink-300/90" aria-hidden="true"></div>
                                <div>
                                    <div className="inline font-semibold text-white">Core Focus:</div> Hust Media publishes original technical documentation focused on scalable web systems, covering architecture, system integration, and practical deployment for stable operations.
                                </div>
                            </div>
                            <div className="flex items-start gap-2.5 text-base leading-7 text-slate-200/95 sm:text-[17px]">
                                <div className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-sky-300/90" aria-hidden="true"></div>
                                <div>
                                    <div className="inline font-semibold text-white">Site Structure:</div> The site connects three core areas: foundational technical articles, applied digital utilities for real workflows, and deep operational notes supporting day-to-day management.
                                </div>
                            </div>
                            <div className="flex items-start gap-2.5 text-base leading-7 text-slate-200/95 sm:text-[17px]">
                                <div className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-300/90" aria-hidden="true"></div>
                                <div>
                                    <div className="inline font-semibold text-white">Key Benefits:</div> By exploring these resources, you gain the actionable insights needed to confidently architect, optimize, and scale high-performance web platforms.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 flex flex-wrap items-center gap-[10px] md:flex-nowrap md:pl-[18px]">
                        <a
                            href="/shop/category/tips_vip"
                            className="inline-flex items-center rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-sm font-semibold text-white no-underline transition hover:bg-white/20"
                        >
                            Browse Articles
                        </a>
                        <a
                            href="/ai/utility/home_ai"
                            className="inline-flex items-center rounded-full border border-white/35 bg-white/16 px-3.5 py-1.5 text-sm font-semibold text-white no-underline transition hover:bg-white/24"
                        >
                            Explore Digital Suite
                        </a>
                    </div>
                </div>

        <div className="mt-4 md:mt-5 md:col-span-1 relative md:pr-1 md:self-stretch">
          <div className="block h-auto md:h-full md:min-h-[175px] w-full sm:max-w-[345px] ml-auto rounded-xl border border-white/10 bg-slate-900/25 p-3 sm:p-3.5 relative flex flex-col items-start justify-center antialiased overflow-hidden transition hover:border-pink-400/30 hover:bg-slate-900/30">
            <div className="absolute inset-0 z-[1] bg-slate-900/24"></div>
            <div className="z-10 w-full px-2 sm:px-3">
              <div className="text-[15px] font-semibold uppercase tracking-[0.04em] text-slate-200">EXPLORE CONTENT</div>
              <div className="mt-2.5 space-y-2 text-slate-100">
                <button
                    type="button"
                    onClick={() => scrollToSection('home-tech-articles')}
                    className="block w-full cursor-pointer text-left text-[15px] font-semibold text-slate-200 transition-all duration-150 hover:text-slate-100 hover:[text-shadow:0_0_4px_rgba(255,255,255,0.3)]"
                >
                    Technical Articles
                </button>
                <button
                    type="button"
                    onClick={() => scrollToSection('home-digital-utilities')}
                    className="block w-full cursor-pointer text-left text-[15px] font-semibold text-slate-200 transition-all duration-150 hover:text-slate-100 hover:[text-shadow:0_0_4px_rgba(255,255,255,0.3)]"
                >
                    Digital Suite
                </button>
                <button
                    type="button"
                    onClick={() => scrollToSection('home-engineering-notes')}
                    className="block w-full cursor-pointer text-left text-[15px] font-semibold text-slate-200 transition-all duration-150 hover:text-slate-100 hover:[text-shadow:0_0_4px_rgba(255,255,255,0.3)]"
                >
                    Engineering Notes
                </button>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-0 z-0 opacity-45">
              <BackgroundBeams_1 />
            </div>
          </div>
        </div>
      </div>
        </section>
    );
}
export function HomeLatestTechnicalInsightsSection({
    glassPanel,
    totalArticlesCount,
    librarySubtitle,
    tipsVipArticles,
    updatedLabel,
    formatDate,
    viewAllLabel,
    tipsVipLoading,
    safeLang,
}) {
    return (
        <section id="home-tech-articles" className={`${glassPanel} enter-library`}>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-0">
                <div>
                    <div className="text-xs uppercase tracking-[0.22em] text-slate-300/80 mb-1">PART ONE — LATEST TECHNICAL INSIGHTS</div>
                    <h2 className="text-xl sm:text-2xl font-bold leading-tight text-white">Technical Articles on Scalable Architecture and System Optimization</h2>
                </div>
                <div className="text-base font-semibold text-white/95">
                    Technical insights • <span className="font-bold text-white">{totalArticlesCount}</span> articles
                </div>
            </div>
            <div className="-mt-1 mb-2 text-left">
                <div className="indent-4 sm:indent-6 text-base leading-6 text-slate-100 sm:text-[17px] sm:leading-7">
                    {librarySubtitle}
                </div>
            </div>

            <div className="space-y-2">
                {tipsVipArticles.map((post) => {
                    const thumbnail = (post?.thumbnail_image || post?.image || '').trim();
                    const hashName = (post?.tips_hash_name || '').toString().trim() || 'Hust Media';
                    return (
                        <Link
                            key={post.id || post.uri}
                            to={`/next/tech/${post.uri}`}
                            reloadDocument={true}
                            className="no-underline block rounded-xl border border-white/15 bg-slate-900/35 p-3 sm:p-3.5 transition hover:border-pink-400/60 hover:bg-slate-900/45"
                        >
                            <div className="flex items-start gap-3">
                                {thumbnail ? (
                                    <img
                                        src={thumbnail}
                                        alt={post?.title || 'tips_vip article'}
                                        loading="lazy"
                                        className="h-16 w-24 sm:h-20 sm:w-32 object-cover rounded-xl border border-white/10 flex-none"
                                    />
                                ) : null}
                                <div className="min-w-0 flex-1">
                                    <div
                                        className="text-base font-semibold text-white leading-snug"
                                        style={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {String(post?.title || '').trim()}
                                    </div>
                                    <div
                                        className="mt-1 text-sm text-slate-300 leading-relaxed"
                                        style={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {post?.description || ''}
                                    </div>
                                    <HomeMetaPills
                                        dateLabel={formatDate(post?.createdate)}
                                        categoryLabel={hashName}
                                    />
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>

            <div className="mt-3 flex justify-center">
                <HomeActionButton to="/shop/category/tips_vip" reloadDocument={true}>
                    {viewAllLabel}
                </HomeActionButton>
            </div>

            {tipsVipLoading && tipsVipArticles.length == 0 ? (
                <p className="mt-3 text-sm text-slate-300">{safeLang == 'vi' ? "Đang tải bài viết..." : "Loading articles..."}</p>
            ) : null}
        </section>
    );
}


export function HomeTechArticles({
    glassPanel,
    latest_version,
    digitalSuiteArticles = [],
    digitalSuiteTotal = null,
}) {
    const useNextOrdersOnce = latest_version == 3 || latest_version == 5;
    const ordersOnceBase = useNextOrdersOnce ? '/next/orders_once' : '/ai/orders_once';
    const formatDate = (value) => {
        if (!value) return '';
        const parsedDate = new Date(String(value).replace(' ', 'T'));
        if (Number.isNaN(parsedDate.getTime())) return String(value).slice(0, 10);
        return parsedDate.toLocaleDateString('en-US');
    };
    const normalizeCategory = (value) => {
        const raw = String(value || '').trim();
        if (!raw) return 'Digital Suite';
        return raw
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const utilityCards = (Array.isArray(digitalSuiteArticles) ? digitalSuiteArticles : []).slice(0, 2).map((item) => {
        const rawDescription = String(item?.description || '').trim();
        return {
            title: String(item?.title || '').trim(),
            image: String(item?.thumbnail_image || item?.image || '').trim(),
            body: rawDescription,
            href: `${ordersOnceBase}/${String(item?.uri || '').trim()}`,
            createdate: item?.createdate,
            categoryName: String(item?.tips_hash_name || '').trim() || normalizeCategory(item?.category),
        };
    });
    const safeUtilityCount = Number.isFinite(Number(digitalSuiteTotal))
        ? Number(digitalSuiteTotal)
        : utilityCards.length;
    return (
        <section id="home-digital-utilities" className={`${glassPanel} enter-stack`}>
            <div className="mb-0 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <div className="mb-1 text-xs uppercase tracking-[0.22em] text-slate-300/80">
                        PART TWO — Digital • Suite
                    </div>
                    <h2 className="text-xl font-bold leading-tight text-white sm:text-2xl">
                        Practical Utilities Built on System Integration
                    </h2>
                </div>
                <div className="text-base font-semibold text-white/95">
                    Digital suite • <span className="font-bold text-white">{safeUtilityCount}</span> utilities
                </div>
            </div>

            <div className="-mt-1 text-left">
                <div className="indent-4 text-base leading-6 text-slate-100 sm:indent-6 sm:text-[17px] sm:leading-7">
                    Alongside the technical articles above, I also keep a small set of practical utilities built from the same foundation of architecture, integration, and stable operation. I first created them in 2024 during my work at an AI-focused company, then rebuilt them into a more reliable version on my own physical server. They use Hugging Face models and run with an NVIDIA RTX 2060 GPU, showing how infrastructure and AI processing are managed in real use.
                </div>
                <div className="mt-2 indent-4 text-base leading-6 text-slate-100 sm:indent-6 sm:text-[17px] sm:leading-7">
                    The current set includes text to speech, speech to text, and image to text. Together, they help handle heavier media and content tasks more smoothly, while showing how scalable system design and practical implementation can support real workflows behind the platform.
                </div>
                <div className="mt-3 space-y-2">
                    {utilityCards.map((card, index) => (
                        <a
                            key={`${card.title}-${index}`}
                            href={card.href}
                            className="block no-underline rounded-xl border border-white/15 bg-slate-900/35 p-3 sm:p-3.5 transition hover:border-pink-400/60 hover:bg-slate-900/45"
                        >
                            <div className="flex items-start gap-3">
                                {card.image ? (
                                    <img
                                        src={card.image}
                                        alt={card.title}
                                        loading="lazy"
                                        className="h-16 w-24 sm:h-20 sm:w-32 object-cover rounded-xl border border-white/10 flex-none bg-white/80"
                                    />
                                ) : null}
                                <div className="min-w-0 flex-1">
                                    <div className="text-base font-semibold text-white leading-snug">
                                        {card.title}
                                    </div>
                                    <div className="mt-1 text-sm text-slate-300 leading-relaxed">
                                        {card.body}
                                    </div>
                                    <HomeMetaPills
                                        dateLabel={formatDate(card.createdate)}
                                        categoryLabel={card.categoryName}
                                    />
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
                <div className="mt-3 flex justify-center">
                    <HomeActionButton href="/ai/utility/home_ai">
                        View all Digital Suite
                    </HomeActionButton>
                </div>
            </div>
        </section>
    );
}

export function HomeEngineeringNotesSection({
    glassPanel,
    engineeringNotesArticles = [],
    engineeringNotesTotal = null,
}) {
    const formatDate = (value) => {
        if (!value) return "";
        const parsedDate = new Date(String(value).replace(" ", "T"));
        if (Number.isNaN(parsedDate.getTime())) return String(value).slice(0, 10);
        return parsedDate.toLocaleDateString("en-US");
    };

    const normalizeCategory = (value) => {
        const raw = String(value || "").trim();
        if (!raw) return "Engineering Notes";
        return raw
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const topNotes = (Array.isArray(engineeringNotesArticles) ? engineeringNotesArticles : []).slice(0, 2);
    const safeNotesTotal = Number.isFinite(Number(engineeringNotesTotal))
        ? Number(engineeringNotesTotal)
        : topNotes.length;
    return (
        <div id="home-engineering-notes" className={`${glassPanel} enter-features`}>
          <div className="flex flex-col md:flex-row gap-5">
            <div className="flex-1">
              <div className="mb-0 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <div className="text-xs uppercase tracking-[0.22em] text-slate-300/80 mb-1">
                    PART THREE — Engineering • NOTES
                  </div>
                  <h2 className="text-xl sm:text-2xl font-bold leading-tight text-white">
                    System Implementation Notes for Integration and Operations
                  </h2>
                </div>
                <div className="text-base font-semibold text-white/95">
                  Engineering notes • <span className="font-bold text-white">{safeNotesTotal}</span> resources
                </div>
              </div>
              <div className="-mt-1 text-left">
                <div className="indent-4 sm:indent-6 text-base leading-6 text-slate-100 sm:text-[17px] sm:leading-7">
                  Alongside the main articles and utilities above, I also keep a set of deeper implementation notes for the platform itself. This section mainly covers system architecture, API contracts, security, deployment, troubleshooting, and monitoring references that help connected components work together more smoothly.
                </div>
                <div className="mt-2 indent-4 sm:indent-6 text-base leading-6 text-slate-100 sm:text-[17px] sm:leading-7">
                  In practice, these notes support integration workflows and everyday operational decisions, not just isolated technical details. They serve as a practical knowledge layer behind the platform, helping the system remain stable, scalable, and easier to manage over time.
                </div>
                {topNotes.map((note, index) => {
                  const thumbnail = String(note?.thumbnail_image || note?.image || "").trim();
                  const categoryName = String(note?.tips_hash_name || "").trim() || normalizeCategory(note?.category);
                  const noteUri = String(note?.uri || "").trim();
                  if (!noteUri) return null;

                  return (
                    <a
                      key={note?.id || `${noteUri}-${index}`}
                      href={`/next/community/docs/${noteUri}`}
                      className={`${index === 0 ? "mt-3" : "mt-2"} block no-underline rounded-xl border border-white/15 bg-slate-900/35 p-3 sm:p-3.5 transition hover:border-pink-400/60 hover:bg-slate-900/45`}
                    >
                      <div className="flex items-start gap-3">
                        {thumbnail ? (
                          <img
                            src={thumbnail}
                            alt={String(note?.title || "Engineering note")}
                            loading="lazy"
                            className="h-16 w-24 sm:h-20 sm:w-32 object-cover rounded-xl border border-white/10 flex-none"
                          />
                        ) : null}
                        <div className="min-w-0 flex-1">
                          <div className="text-base font-semibold text-white leading-snug">
                            {String(note?.title || "").trim()}
                          </div>
                          <div className="mt-1 text-sm text-slate-300 leading-relaxed">
                            {String(note?.description || "").trim()}
                          </div>
                          <HomeMetaPills
                            dateLabel={formatDate(note?.createdate)}
                            categoryLabel={categoryName}
                            categoryClassName="font-medium"
                          />
                        </div>
                      </div>
                    </a>
                  );
                })}
                <div className="mt-3 flex justify-center">
                  <HomeActionButton href="/ai/utility/home_notes">
                    View all Notes
                  </HomeActionButton>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
}
